import { call, put } from 'redux-saga/effects';
import {
  sendUploadLinkByUserRequest,
  sendUploadLinkByUserSuccess,
  sendUploadLinkByUserFailure,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* sendUploadLinktoPatientByUser(action) {
  yield put(sendUploadLinkByUserRequest());
  const patientId = action.payload.param.patientId;
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/patient/sendUploadLink/${patientId}`
    );
    if (result) {
      action.callback(result.data.data);
      yield put(sendUploadLinkByUserSuccess());
    } else {
      yield put(sendUploadLinkByUserFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(sendUploadLinkByUserFailure(e));
  }
}

export const sendUploadLinkByUserSagaAction = (param, cb) => ({
  type: SagaTypes.SEND_UPLOAD_LINK_TO_PATIENT,
  payload: { param },
  callback: cb,
});
